import Hr from '@creator/ui/components/Hr/Hr';
import MenuItem from '@creator/ui/components/Menu/MenuItem';
import { useStoreState } from '@src/model/hooks';
import { Fragment, memo } from 'react';

export interface DomainMainMenuProps {
    className?: string;
}

const DomainMainMenu: React.FC<DomainMainMenuProps> = props => {
    const { className = '' } = props;
    const domainMainMenu = useStoreState(state => state.config.mainMenu);

    if (!domainMainMenu || !domainMainMenu.length) return null;

    return (
        <Fragment>
            <menu className={className}>
                {domainMainMenu.map(item => (
                    <MenuItem key={item.id} item={item} />
                ))}
            </menu>
            <Hr className="my-2" />
        </Fragment>
    );
};

export default memo(DomainMainMenu);
